<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: '#003534',
    }">
        <div class="name_pop">
            <van-row class="title">
                <van-col span="22" style="display: flex; justify-content: center; align-items: center;">
                    {{ $t('profile.brandName') }}
                </van-col>
                <van-col span="2">
                    <img src="@/assets/profile/cs_close_n.png" alt="" @click="close">
                </van-col>
            </van-row>

            <div class="content">
                <InputField v-model="userName" :labelText="$t('profile.enterNickName')" />


                <!-- <div class="btn_container">
                    <MainButton title="Salvar" :activeStatus="isUpdateField" @click="onUpdateNickName" />
                </div> -->
                <div class="defaultButton">
                    <van-button :disabled="!isUpdateField" @click="onUpdateNickName" class="custom-save-btn">
                        {{ $t('profile.save') }}
                    </van-button>
                </div>

            </div>
        </div>
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    </van-popup>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import InputField from './inputField.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import { useUserStore } from '@/stores/user'
import MainButton from '../../components/common/mainButton.vue'
import { updateNickName } from '@/view/profile/supportScript'

const userStore = useUserStore()
const id = computed(() => userStore.id)
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const userName = ref('')
const isUpdateField = ref(false)

const open = (name: string) => {
    userName.value = name
    show.value = true
}

const close = () => {
    show.value = false
}

const onUpdateNickName = () => {
    updateNickName(id.value, userName.value, show, toastContent, isSuccess, statusRef)
}

watch(() => userName.value, (newVal) => {
    if (newVal) {
        isUpdateField.value = true
    } else {
        isUpdateField.value = false
    }

})
defineExpose({
    open,
})

</script>
<style scoped>

.van-popup {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important;
    border: 1px solid rgba(255, 255, 255, 0.10) !important;
    box-shadow: 0 -4px 8px 0 rgb(9, 15, 31), inset 0 1px 0 0 rgba(255, 255, 255, .25) !important;
    backdrop-filter: blur(20px) !important;
    height: 100vh;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.title {
    padding: 10px 10px;
    font-size: 14px;
    background: #024a49 !important;
    color: #fff;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.title img {
    width: 25px;
    padding-top: 5px;
    opacity: 0.6;
}

.van-overlay {
    background-color: rgb(9, 15, 31)
}


.content {
    padding: 0px 15px;
}

.label {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.45);
}

.btn_container {
    padding: 30px 90px;
}

.dilshan {
    padding: 0 15px;
}

.defaultButton {
    margin: 40px 0;
    display: flex;
    justify-content: center;
}

::v-deep(.custom-save-btn.van-button) {
    width: 100%;
    background:linear-gradient(90deg, rgb(1, 73, 72) -18%, rgb(15, 177, 175) 122%);
    border-color: #00615f !important;
    color: #fff !important;
    height: 50px;
    border-radius: 5px;
    font-size: 15px;
   
}


::v-deep(.custom-save-btn.van-button--disabled) {
    background:linear-gradient(90deg, rgb(1, 73, 72) -18%, rgb(15, 177, 175) 122%);
    border-color: #00615f !important;
    opacity: 0.7;
}
</style>